import React from "react";

export const StatusChip = (props: StatusChipProps) => {
  const { status, label } = props;

  return <div className={`module-status-chip is-${status} one-line-text`}>{label}</div>;
};

interface StatusChipProps {
  status?: string;
  label: string;
}
